import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export default function PricingScreen() {
  const { orgSlug, dealId } = useParams();
  return <Navigate to={`/org/${orgSlug}/deal/${dealId}/offer`} replace />;
}
